<div class="content">
  <div class="title">{{ title }}</div>
  <ng-content></ng-content>
</div>
